import { AfterViewInit, Component } from "@angular/core";
import { NgXCookies } from "src/app/services/ngx-cookies";
import { generalAnimations } from "src/app/_animations/general.animations";
import { ApiService } from "src/app/api/api.service";
import { ILocalizedComponent } from "src/app/ILocalizedComponent";
import { ELocale } from "src/app/localization/ELocale";
import { LocaleService } from "src/app/localization/locale.service";
import { EntryService } from "src/app/services/entry.service";
import {
  ICategories,
  IFilterCategories,
  IFilterCategory,
} from "src/rest-interfaces/ICategory";
import {
  IEntryInnovationen,
  IEntryInnovationenPreviewItem,
} from "src/rest-interfaces/innovationen/IEntryInnovationen";
import { IFIlterModelInnovationen } from "src/rest-interfaces/innovationen/IFilterModelInnovationen";
import { Title } from "@angular/platform-browser";

@Component({
  selector: "app-innovationen",
  templateUrl: "./innovationen.component.html",
  animations: [generalAnimations],
})
export class InnovationenComponent implements ILocalizedComponent {
  private readonly ENTRIES_PER_PAGE = 24;
  private readonly COOKIE_FILTER_NAME = "__InnovationenFilter";

  public content: IEntryInnovationen;

  public filteredInnos: IEntryInnovationenPreviewItem[] = [];
  public filteredInnosCount = 0;
  public filterCats: IFilterCategories;
  public showChildrenCat: IFilterCategory;
  public selectedCats: IFilterCategories = [];
  public filterModel: IFIlterModelInnovationen = {
    term: "",
    categories: {},
    page: 1,
    loadbefore: false,
  };

  public hasMorePages = false;
  public isLoadingMore = false;

  constructor(
    private entrySvc: EntryService,
    private localeSvc: LocaleService,
    private API: ApiService,
    private title: Title,
  ) {
    this.entrySvc
      .customControllerUri<IEntryInnovationen>(this.localeSvc.RouterUri)
      .subscribe(
        (entry) => {
          this.content = entry;
          this.filterCats = this.getFilterCatsAsArray(entry.innovationenFilter);
          this.loadFilteredInnovationen();
          this.title.setTitle(`PIRMIN JUNG - ${entry.title}`);
        },
        (error) => {
          console.error(error);
        },
      );
  }

  public loadFilteredInnovationen(
    _filterChanged = false,
    _loadBefore = false,
  ): void {
    if (this.isLoadingMore) return;

    this.isLoadingMore = true;

    // first load
    if (!_loadBefore) {
      NgXCookies.setCookie(
        this.COOKIE_FILTER_NAME,
        JSON.stringify(this.filterModel),
        1,
        "hours",
      );
    }

    this.filterModel.loadbefore = _loadBefore;

    this.API.post<IFIlterModelInnovationen, IEntryInnovationenPreviewItem[]>(
      "/innovationen/filter",
      this.filterModel,
    ).subscribe(
      (response) => {
        this.filteredInnos = response;
        this.filteredInnosCount = this.filteredInnos.length;
      },
      (error) => {
        console.error("error:", error);
      },
      () => {
        this.isLoadingMore = false;
      },
    );
  }

  public getLocaleChangeUrl(targetLocale: ELocale): string {
    const locUrlProperty = "url_" + targetLocale;
    if (this.content && this.content.hasOwnProperty(locUrlProperty)) {
      return this.content[locUrlProperty];
    }
  }

  public onCatTreeClear() {
    this.showChildrenCat = null;
    this.filterModel.categories = {};
    this.filterCats.forEach((cat) => (cat.selected = false));
    this.selectedCats = [];
    this.loadFilteredInnovationen();
  }

  public isCatFilterEmpty(): boolean {
    return (
      Object.keys(this.filterModel.categories).length === 0 &&
      !this.showChildrenCat
    );
  }

  public handleFilterCatClick(cat: IFilterCategory) {
    if (cat.children.length) {
      // has children
      if (this.showChildrenCat != cat) this.showChildrenCat = cat;
      else this.showChildrenCat = null;
    } else {
      // no children
      cat.selected = !cat.selected;
      if (cat.selected) {
        this.filterModel.categories[cat.slug] = {};
        this.selectedCats.push(cat);
      } else {
        delete this.filterModel.categories[cat.slug];
        this.selectedCats = this.selectedCats.filter(
          (c) => c.slug !== cat.slug,
        );
      }

      this.loadFilteredInnovationen();
    }
  }

  private getFilterCatsAsArray(cats: ICategories): IFilterCategories {
    return Object.keys(cats).map((catId) => {
      const cat = cats[catId] as any as IFilterCategory;
      if (cat.children) {
        cat.children = this.getFilterCatsAsArray(cat.children as any);
      } else {
        cat.children = [];
      }
      return cat;
    });
  }
}
